import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../features/components/Form/MultiSelectBox'

import { getGoogleLanguages } from '../../../modules/actions/googleConstants'
import {
  googleLanguagesIsLoadingSelector,
  googleLanguagesSelector,
  googleLanguagesWasLoadedSelector
} from '../../../modules/selectors/googleConstants'
import { selectedGoogleAdAccountSelector } from '../../../modules/selectors/adAccounts'

const GoogleLanguages = ({ name, value, setFieldValue }) => {
  const dispatch = useDispatch()

  const languages = useSelector(googleLanguagesSelector)
  const languagesIsLoading = useSelector(googleLanguagesIsLoadingSelector)
  const languagesWasLoaded = useSelector(googleLanguagesWasLoadedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const formattedLanguages = useMemo(
    () =>
      languages &&
      languages.map(item => {
        const { id, name, resource_name } = item

        return { value: id, label: name, resource_name }
      }),
    [languages]
  )

  useEffect(() => {
    if (!languagesWasLoaded) {
      dispatch(
        getGoogleLanguages({
          account: selectedAdAccountId
        })
      )
    }
  }, [dispatch, selectedAdAccountId, languagesWasLoaded])

  return (
    <MultiSelectBox
      placeholder={'ADD A LANGUAGE'}
      name={name}
      options={formattedLanguages}
      value={value}
      isLoading={languagesIsLoading}
      setFieldValue={setFieldValue}
    />
  )
}

export default GoogleLanguages
